export const REGESTRATION_NUMBER_FILTERS = [
	{
		"Keyword": "TBA"
	},
	{
		"Keyword": ""
	},
	{
		"Keyword": "NA"
	},
	{
		"Keyword": "TBC"
	},
	{
		"Keyword": "000000"
	},
	{
		"Keyword": "N/A"
	},
	{
		"Keyword": "NEW"
	},
	{
		"Keyword": "T B A"
	},
	{
		"Keyword": ". "
	},
	{
		"Keyword": "BIDVEST"
	},
	{
		"Keyword": "TOBEAD"
	},
	{
		"Keyword": "GP"
	},
	{
		"Keyword": "UNKNOWN"
	},
	{
		"Keyword": "0"
	},
	{
		"Keyword": "TEST"
	},
	{
		"Keyword": "PERMIT"
	},
	{
		"Keyword": "TB"
	},
	{
		"Keyword": "T.B.A"
	},
	{
		"Keyword": "T"
	},
	{
		"Keyword": "TBS"
	},
	{
		"Keyword": "TEMP"
	},
	{
		"Keyword": "To Be Advised"
	},
	{
		"Keyword": "N"
	},
	{
		"Keyword": "tba00"
	},
	{
		"Keyword": "TAB"
	},
	{
		"Keyword": "nd"
	},
	{
		"Keyword": "USED"
	},
	{
		"Keyword": "TBADVIS"
	},
	{
		"Keyword": "Tbn"
	},
	{
		"Keyword": "TBA000"
	},
	{
		"Keyword": "CA"
	},
	{
		"Keyword": "NONE"
	},
	{
		"Keyword": "00"
	},
	{
		"Keyword": "TBA123EC"
	},
	{
		"Keyword": "00000000000000000000"
	},
	{
		"Keyword": "Nba"
	},
	{
		"Keyword": ".TBA"
	},
	{
		"Keyword": "Tbt"
	},
	{
		"Keyword": "="
	},
	{
		"Keyword": "CR20GLGP"
	},
	{
		"Keyword": "Tobeadvised"
	},
	{
		"Keyword": ".."
	},
	{
		"Keyword": "TBAT"
	},
	{
		"Keyword": "A"
	},
	{
		"Keyword": " TBA"
	},
	{
		"Keyword": "NA..."
	},
	{
		"Keyword": "TBA001"
	},
	{
		"Keyword": "T Ba"
	},
	{
		"Keyword": "TBA00000"
	},
	{
		"Keyword": "NOT PROVIDED"
	},
	{
		"Keyword": "123TBA"
	},
	{
		"Keyword": "Npstemp"
	},
	{
		"Keyword": "TBA0000"
	},
	{
		"Keyword": "TBA-VOLKSWAGEN"
	},
	{
		"Keyword": "0000000000"
	},
	{
		"Keyword": "tna"
	},
	{
		"Keyword": "Tb A"
	},
	{
		"Keyword": "..."
	},
	{
		"Keyword": "TBAAA"
	},
	{
		"Keyword": "TBA123GP"
	},
	{
		"Keyword": "TBA By Client"
	},
	{
		"Keyword": "00000"
	},
	{
		"Keyword": "123"
	},
	{
		"Keyword": "...."
	},
	{
		"Keyword": "Fs"
	},
	{
		"Keyword": "00000000000"
	},
	{
		"Keyword": "tTBa"
	},
	{
		"Keyword": "TA"
	},
	{
		"Keyword": "G"
	},
	{
		"Keyword": "$$$$$$$$$$$$$$$$$$$$"
	},
	{
		"Keyword": "Unkwn"
	},
	{
		"Keyword": "THA"
	},
	{
		"Keyword": "NA.."
	},
	{
		"Keyword": "TBVA"
	},
	{
		"Keyword": "TOBEDA"
	},
	{
		"Keyword": "000"
	},
	{
		"Keyword": "00000000000000"
	},
	{
		"Keyword": "000000000000000"
	},
	{
		"Keyword": "0000000000000"
	},
	{
		"Keyword": "0000000000000000"
	},
	{
		"Keyword": "000000000000"
	},
	{
		"Keyword": "......"
	},
	{
		"Keyword": "000000000"
	},
	{
		"Keyword": "AFAPXXMJ2PDA32710"
	},
	{
		"Keyword": "000000000000000000"
	},
	{
		"Keyword": "....."
	},
	{
		"Keyword": "0000000000000000000"
	},
	{
		"Keyword": "00000000000000000"
	},
	{
		"Keyword": "......."
	},
	{
		"Keyword": "00000000"
	},
	{
		"Keyword": "TCB"
	},
	{
		"Keyword": "........"
	},
	{
		"Keyword": "BA"
	},
	{
		"Keyword": "-"
	},
	{
		"Keyword": "Yba"
	},
	{
		"Keyword": "RBA"
	},
	{
		"Keyword": "`tba"
	},
	{
		"Keyword": "D"
	},
	{
		"Keyword": "TGBA"
	},
	{
		"Keyword": ".........."
	},
	{
		"Keyword": "**********"
	},
	{
		"Keyword": "AHT140491421842"
	},
	{
		"Keyword": "ENJINNR"
	},
	{
		"Keyword": "1"
	},
	{
		"Keyword": "SA2KPDA32710"
	},
	{
		"Keyword": "GVM/BVM"
	},
	{
		"Keyword": "1TR1402142914"
	},
	{
		"Keyword": "Tva"
	},
	{
		"Keyword": "1.4"
	},
	{
		"Keyword": "0000"
	},
	{
		"Keyword": "TBA`"
	},
	{
		"Keyword": "........."
	}
]